import React, { useEffect } from 'react';
import './MedicalBanner1.css';
import { FaUserMd } from 'react-icons/fa';
import bannerImage from './assests/lab1.png'; // ✅ Replace with your image path

const MedicalBanner1 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="medical-banner">
      <div className="left-content">
        <FaUserMd className="icon" />
        <p className="blue-text">
          Products are individually tested for quality control before sale.
          <br />
          Products on this website can only be purchased through our global partners.
        </p>

        {/* ✅ Image instead of video */}
        <div className="image-container">
          <img src={bannerImage} alt="Health Product" className="banner-img" />
        </div>
      </div>

      <div className="right-content">
        <h2>The Quality Of Your Life Through Better Health Products.</h2>
        <p>
          Our goal is to deliver quality of care in a courteous, respectful, and compassionate manner.
          We hope you will allow us to care for you and to be the first and best choice for healthcare.
        </p>
        <p>
          Our products are manufactured in our Current Good Manufacturing Practices facility to ensure optimal quality.
        </p>
        <ul>
          <li>
            ✅ <span className="bold">We conduct a range of tests</span> to help us work out why you're not feeling well and determine the right treatment for you.
          </li>
          <li>
            ✅ <span className="bold">We have become synonymous with our brand and reputation.</span> We are continuously focusing on improving both the standard of our product and our business.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MedicalBanner1;
